import { ReactNode } from 'react';

import { Box, Flex } from '@bonusly/design-system';

interface BizySidePanelHeaderProps {
	left: ReactNode;
	right?: ReactNode;
}

export function BizySidePanelHeader({ left, right }: BizySidePanelHeaderProps) {
	return (
		<Flex align="center" justify="space-between" gap={0} pl={2} pr={3} py={{ base: 4, sm: 3 }} flexShrink={0}>
			<Box minW={0} flex={1} overflow="hidden">
				{left}
			</Box>
			{right && <Box flexShrink={0}>{right}</Box>}
		</Flex>
	);
}
